var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"times\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.25241 5.4992L11.0715 1.68901C11.2387 1.52177 11.3327 1.29493 11.3327 1.05842C11.3327 0.821899 11.2387 0.595069 11.0715 0.427826C10.9042 0.260582 10.6774 0.166626 10.4409 0.166626C10.2044 0.166626 9.97754 0.260582 9.8103 0.427826L6.00011 4.2469L2.18991 0.427826C2.02267 0.260582 1.79584 0.166626 1.55932 0.166626C1.3228 0.166626 1.09597 0.260582 0.928731 0.427826C0.761488 0.595069 0.667531 0.821899 0.667531 1.05842C0.667531 1.29493 0.761488 1.52177 0.928731 1.68901L4.74781 5.4992L0.928731 9.30939C0.845485 9.39196 0.779412 9.49019 0.734321 9.59842C0.689231 9.70665 0.666016 9.82274 0.666016 9.93999C0.666016 10.0572 0.689231 10.1733 0.734321 10.2816C0.779412 10.3898 0.845485 10.488 0.928731 10.5706C1.0113 10.6538 1.10953 10.7199 1.21776 10.765C1.32599 10.8101 1.44208 10.8333 1.55932 10.8333C1.67657 10.8333 1.79266 10.8101 1.90089 10.765C2.00912 10.7199 2.10735 10.6538 2.18991 10.5706L6.00011 6.7515L9.8103 10.5706C9.89287 10.6538 9.9911 10.7199 10.0993 10.765C10.2076 10.8101 10.3236 10.8333 10.4409 10.8333C10.5581 10.8333 10.6742 10.8101 10.7825 10.765C10.8907 10.7199 10.9889 10.6538 11.0715 10.5706C11.1547 10.488 11.2208 10.3898 11.2659 10.2816C11.311 10.1733 11.3342 10.0572 11.3342 9.93999C11.3342 9.82274 11.311 9.70665 11.2659 9.59842C11.2208 9.49019 11.1547 9.39196 11.0715 9.30939L7.25241 5.4992Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal_close.0abe6586feb22e15b83245e3eae5787a.svg";
export { ForwardRef as ReactComponent };